import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import styles from "./jargon-buster.module.css";
import sharedStyles from "../../landing-feature-electric-cars.module.css";
import { Wrapper } from "@cinch-nx/shared-ui";
const JargonList = ({ jargon  })=>{
    const { title , text  } = jargon;
    const textContent = renderWithResolver(text);
    return /*#__PURE__*/ _jsxs("li", {
        className: styles.jargonList,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: styles.subheading,
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                children: textContent
            })
        ]
    });
};
export const JargonBuster = ({ jargonContent  })=>{
    const { title , body , jargonList  } = jargonContent;
    const bodyContent = renderWithResolver(body);
    return /*#__PURE__*/ _jsx("section", {
        className: styles.container,
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            isSlim: true,
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: sharedStyles.heading,
                    children: title
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.subheading,
                    children: bodyContent
                }),
                /*#__PURE__*/ _jsx("ul", {
                    children: jargonList.map((jargonItem)=>/*#__PURE__*/ _jsx(JargonList, {
                            jargon: jargonItem
                        }, `jargon-${jargonItem.title}`))
                })
            ]
        })
    });
};
